export function toCsv(rows: Array<Record<string, unknown>>): string {
  if (!rows.length) return '';
  const headers = Array.from(rows.reduce((set, row) => { Object.keys(row).forEach((key) => set.add(key)); return set; }, new Set<string>()));
  const escape = (value: unknown) => { if (value === null || value === undefined) return ''; const str = String(value).replace(/"/g, '""'); return `"${str}"`; };
  const lines = rows.map((row) => headers.map((h) => escape(row[h])).join(','));
  return `${headers.join(',')}
${lines.join('\n')}`;
}
export function downloadCsv(filename: string, rows: Array<Record<string, unknown>>): void {
  if (typeof window === 'undefined') return;
  const blob = new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; link.download = filename; link.click(); URL.revokeObjectURL(url);
}
